import {
  Column,
  Container,
  Row,
  Text,
  Button,
  Spacer,
  Picture
} from '@smuchile/pkg-unimarc-components'
import { getGlobalStyle } from '@smuchile/pkg-unimarc-components/helpers'
import { useContentful, useMobile } from '@smuchile/pkg-unimarc-hooks'
import { NO_RESULT_CHEESE } from 'shared/utils/constanst'

interface ImageSizesProps {
  width: string
  height: string
}
interface CarouselErrorProps {
  hideButton?: boolean
  handleReload?: () => void
  customImageSize?: ImageSizesProps
  modalPLP?: boolean
}

const getPropsByPortView = ({
  isMobile = false,
  modalPLP = false,
  customImageSize
}) => {
  if (isMobile)
    return {
      containerMinHeight: '100%',
      containerPadding: '10px 0 0 0',
      columnPadding: '0',
      buttonWidth: '295px',
      imageWidth: customImageSize?.width ?? '200px',
      imageHeight: customImageSize?.height ?? '250px'
    }

  return {
    containerMinHeight: '505px',
    containerPadding: modalPLP ? '0' : '68px 0 0 0',
    columnPadding: '42px 0 0 0',
    buttonWidth: '410px',
    imageHeight: customImageSize?.height ?? '369px',
    imageWidth: customImageSize?.width ?? '320px'
  }
}
export const CarouselError = ({
  hideButton = false,
  customImageSize,
  modalPLP = false
}: CarouselErrorProps) => {
  const { innerWidth } = useMobile()
  const isMobile = innerWidth < 1280
  const portViewSizes = getPropsByPortView({
    isMobile,
    modalPLP,
    customImageSize
  })
  const noResultCheese = useContentful({
    id_contentful: 'queso_sin_resultados',
    options: {
      'sys.id': NO_RESULT_CHEESE[0]
    },
    type: 'assets'
  })
  const noResultCheeseImage =
    noResultCheese?.data?.['items']?.[0]?.fields?.file?.url || ''

  const modalHeight = () => {
    if (modalPLP && !isMobile) {
      return '550px'
    }
    return 'max-content'
  }

  const handleGoBackFunction = () => {
    window.location.reload()
  }
  const goBack = handleGoBackFunction

  return (
    <Container
      alignItems='center'
      backgroundColor={getGlobalStyle('--color-background-white')}
      justifyContent='center'
      minHeight={modalHeight()}
    >
      <Container
        alignItems='center'
        backgroundColor={getGlobalStyle('--color-background-white')}
        customWidth='90'
        gap='45px'
        justifyContent='center'
        maxWidth='1220px'
        minHeight={portViewSizes.containerMinHeight}
        padding={portViewSizes.containerPadding}
      >
        <Column
          alignItems='end'
          maxWidth='410px'
          padding={portViewSizes.columnPadding}
        >
          {isMobile && (
            <Column alignItems='center'>
              <Picture
                height='250px'
                src={noResultCheeseImage}
                width='200px'
              />
              <Spacer.Horizontal size={8} />
            </Column>
          )}
          <Row justifyContent='center'>
            <Text
              fontSize={isMobile ? 'lg' : '5xl'}
              fontWeight='semibold'
              textAlign='center'
            >
              ¡Ups! Lo sentimos
            </Text>
          </Row>
          <Spacer.Horizontal size={16} />
          <Row
            alignSelf='center'
            maxWidth='max-content'
          >
            <Text
              customColor={getGlobalStyle('--color-neutral-gray-dark')}
              fontSize='lg'
              textAlign='center'
            >
              El producto que buscas no tiene otros similares
            </Text>
          </Row>
          <Spacer.Horizontal size={isMobile ? 8 : 64} />
          <Spacer.Horizontal size={18} />
          <Row
            alignSelf='center'
            justifyContent='center'
            maxWidth='321px'
          >
            {!hideButton && (
              <Button
                background={getGlobalStyle('--color-base-black')}
                borderRadius={getGlobalStyle('--border-radius-lg')}
                label='Volver'
                onClick={goBack}
                size='large'
                width={portViewSizes.buttonWidth}
              />
            )}
          </Row>
        </Column>
        {!isMobile && (
          <Column width='min-content'>
            <Picture
              height='369px'
              src={noResultCheeseImage}
              width='320px'
            />
          </Column>
        )}
      </Container>
    </Container>
  )
}
